module.exports = __webpack_public_path__ + "img/cherry.dd2213ae.png";